
import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DeviceChecker from "./deviceChecker";

const Voting = lazy(() => import("./voting"));
const Results = lazy(() => import("./results"));
function App() {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route path="/" element={<Voting />} />
          <Route path="/device-check" element={<DeviceChecker />} />
          <Route path="/results" element={<Results />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
